/**
 * Admin Panel Reducer
 * 
 * Manages UI state for the admin panel.
 * Server state is handled by React Query.
 */

import type { AdminState, AdminAction } from "@/types/state";

/**
 * Initial admin UI state
 */
export const initialAdminState: AdminState = {
  // UI State
  activeTab: 'users',
  scrollPosition: 0,
};

/**
 * Admin UI reducer
 */
export function adminReducer(
  state: AdminState,
  action: AdminAction
): AdminState {
  switch (action.type) {
    case 'SET_ACTIVE_TAB':
      return { ...state, activeTab: action.payload };

    case 'SET_SCROLL_POSITION':
      return { ...state, scrollPosition: action.payload };

    case 'RESET_ADMIN':
      return initialAdminState;

    default:
      return state;
  }
}

/**
 * Action creators for cleaner dispatch calls
 */
export const adminActions = {
  setActiveTab: (tab: AdminState['activeTab']): AdminAction => ({
    type: 'SET_ACTIVE_TAB',
    payload: tab,
  }),
  
  setScrollPosition: (position: number): AdminAction => ({
    type: 'SET_SCROLL_POSITION',
    payload: position,
  }),
  
  resetAdmin: (): AdminAction => ({
    type: 'RESET_ADMIN',
  }),
};
